(function ($) {
  $("body").on("click", ".accordion-group-tab", function (e) {
    e.preventDefault();

    var $this = $(this);
    var $accordionGroup = $this.closest(".accordion-grid");
    var $tabs = $accordionGroup.find(".accordion-group-tab");
    var $panels = $accordionGroup.find(".accordion-group-panel");

    // Deactivate all tabs and hide all panels
    $tabs.attr("aria-selected", "false");
    $panels.attr("hidden", true);

    // Activate the clicked tab and show the corresponding panel
    $this.attr("aria-selected", "true");
    var panelId = $this.attr("aria-controls");
    var $targetPanel = $("#" + panelId);

    $targetPanel.attr("hidden", false);

    // TODO: NEED TO GET THIS WORKING. At the moment on resize, if the panel is hidden it may not reize the heighrs
    $targetPanel.find(".accordion").each(function () {
      if (this._accordionInstance) {
        console.log("Updating accordion panel heights for:", this);
        // this._accordionInstance.updateOpenPanelHeights();
      }
    });
  });
})(jQuery);
